/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import CLog, { LogTypes } from '../Utility/ComponentLogger';
import Effect from './Effect';
import EffectSequence from './EffectSequence';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class TriggerEffectSequenceEffect extends Effect
{
    @property({ type: InjectableComponent, override: true })
    protected reference: InjectableComponent<EffectSequence> = new InjectableComponent();

    @property
    protected ignoreCustomLead: boolean = false;

    private _hasConfiguredComplete: boolean = false;

    protected setContexts(): void
    {
        super.setContexts();
        this.reference.SetContext(EffectSequence);

        this.configureReference();
    }

    private configureReference(): void
    {
        if (this.ignoreCustomLead) { return; }

        const customStateLead: string = 'State.Custom.';
        if (this.reference.InstanceID.startsWith(customStateLead)) { return; }

        this.reference.InstanceID = customStateLead + this.reference.InstanceID;
    }

    protected trigger = (): void =>
    {
        this.reference.WithValue(effectSequence =>
            {
                if (!this._hasConfiguredComplete)
                {
                    this.reference.WithValue(ref => ref.OnComplete(() => this.complete()),
                        () => CLog.warn('No effect configured', LogTypes.Initialization, this));
                    this._hasConfiguredComplete = true;
                }
                effectSequence.Trigger();
            },
            () =>
            {
                CLog.warn('No effect sequence.', LogTypes.Initialization, this);
                this.complete();
            });
    }
}
